module.exports = __webpack_public_path__ + "static/media/logoDark.c9e83806.png";